<script>
import { mapGetters } from 'vuex'
import axios from 'axios'
export default
{
    name: 'mv-wishlist-form',

    props:
    {
        model: Object,
        edit: Boolean,
    },

    methods:
    {
        save()
        {
            this.$emit('save')
        },

        submit()
        {
            this.$refs.form.submit()
        },

        addFile(file)
        {
            this.model.attachments.push(file)
        },

        removeFile(file)
        {
            for (let i = 0; i < this.model.attachments.length; ++i)
            {
                const item = this.model.attachments[i]
                if (file.id == item.id)
                {
                    this.model.attachments.splice(i, 1)
                }
            }

        },

        fetchCategories()
        {
            axios.get(process.env.API_URL + '/v1/admin/wishlistcategories').then(({data}) => {
                this.categories = data
            })
        },

    },

    data()
    {
        return {
            categories: []
        }
    },

    mounted()
    {
        this.fetchCategories()
    },

}
</script>

<template>
<div class="container">
    <form @submit.prevent.stop="save" ref="form">
        <div class="form-group row">
            <label for="name" class="col-md-4 control-label">
                {{ $t('WISHLIST.NAME') }}
            </label>
            <div class="col-md-6">
                <input type="text" class="form-control" v-model="model.name" required>
            </div>
        </div>

        <div class="form-group row">
            <label for="name" class="col-md-4 control-label">
                {{ $t('WISHLIST.CATEGORIES') }}
            </label>
            <div class="col-md-6">
                <v-select :options="categories" v-model="model.categories" label="name" multiple>
                    <template slot="option" slot-scope="option">
                        <div class="row option-row">
                            <div class="col-sm-2 hidden-sm hidden-xs">
                                <div v-if="option.attachments && option.attachments.length">
                                    <img :src="option.attachments[0].thumbnail_url" height="64">
                                </div>
                            </div>
                            <div class="col-sm-10">
                                <div class="text">
                                    {{ option.name }}
                                </div>
                            </div>
                        </div>
                    </template>
                </v-select>
            </div>
        </div>

        <div class="form-group row">
            <label for="name" class="col-md-4 control-label">
                {{ $t('WISHLIST.ACTIVE') }}
            </label>
            <div class="col-md-6">
                <div class="checkbox">
                    <label>
                        <input type="checkbox" v-model="model.active">
                        <span v-if="model.active" class="label label-success">
                            {{ $t('GENERAL.YES')}}
                        </span>
                        <span v-else class="label label-warning">
                            {{ $t('GENERAL.NO')}}
                        </span>
                    </label>
                </div>
            </div>
        </div>
    </form>
</div>
</template>



// WEBPACK FOOTER //
// src/components/forms/WishlistForm.vue